/*
 * Public API Surface of static-table
 */

export * from './lib/static-table.component';
export * from './lib/static-table.module';
